/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-07-09 17:46:30
 * @LastEditTime: 2019-09-09 13:32:16
 * @LastEditors: yingbin
 */
class UTILS {
	/**
	 * @description: 检查环境
	 * @param : 
	 * @return: {string}
	 */
	checkEnv() {
		if (location.hostname === 'open.yundaex.com') {	
			return 'http://open.yundaex.com/openapi-interface'
		} else {
			return 'http://uatkyweixin.yundasys.com/openapi-interface'
		}
	}
	/**
	 * 行为验证码校验 检查环境
	 */
	checkDomain() {
		// if (location.hostname === 'openapi.yundaex.com') {        //判断域名更改
		if (location.hostname === 'open.yundaex.com') {
			// return 'https://openapi.yundaex.com/openapi-interface'  旧域名
			return 'http://open.yundaex.com'
		} else {
			return 'http://uatkyweixin.yundasys.com'
		}
	}
	/**
	 * 获取当前环境
	 */
	getEnv() {
		// if (location.hostname === 'openapi.yundaex.com') {        //判断域名更改
		if (location.hostname === 'open.yundaex.com') {	
			// return 'https://openapi.yundaex.com/openapi-interface'  旧域名
			return 'pro'
		} else {
			return 'dev'
		}
	}
	/** 嵌入页面域名 */
	copyUrl(){
		if (location.hostname === 'open.yundaex.com') {	
			return 'http://op.yundasys.com/'
		} else {
			return 'http://weixin.yundasys.com/'
		}
	}
	/**
	 * 设置cookie值
	 * @param {*} name  cookie key
	 * @param {*} value 值
	 * @param {*} days 过期时间
	 */
	setCookie(name, value, days = 30) {
		let exp = new Date();
		exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; path=/";  // 加上 ; path=/   防止cookie删不掉问题
	}

	/**
	 * 获取cookie
	 * @param {*} name key
	 */
	getCookie(name) {
		let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		// eslint-disable-next-line no-cond-assign
		if (arr = document.cookie.match(reg))
			return unescape(arr[2]);
		else
			return null;
	}

	/**
	 * 删除cookie
	 * @param {*} name 
	 */
	removeCookie(name) {
		let exp = new Date();
		exp.setTime(exp.getTime() - 10000);
		// eslint-disable-next-line no-undef
		var cval = this.getCookie(name);
		if (cval != null)
				this.setCookie(name,"",-1) // 将过期时间设为-1 可直接删除cookie
			// document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
	}

	/**
	 * @description:时间格式化 
	 * @param : {Date}date, fmt
	 */
	formatTime(date, fmt) {
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
		}
		let o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'h+': date.getHours(),
			'm+': date.getMinutes(),
			's+': date.getSeconds()
		};
		for (let k in o) {
			if (new RegExp(`(${k})`).test(fmt)) {
				let str = o[k] + '';
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
			}
		}
		return fmt;
	}

	padLeftZero(str) {
		return ('00' + str).substring(str.length);
	}

	/**
	 * @description:将URL后的参数转换成对象 Object
	 * @param :{string} str
	 * @return:{Object} obj
	 */
	urlToObj(str) {
		var obj = {};
		var arr1 = str.split("?");
		var arr2 = arr1[1].split("&");
		for (var i = 0; i < arr2.length; i++) {
			var res = arr2[i].split("=");
			obj[res[0]] = res[1];
		}
		return obj;
	}

	removeArray(arr,val) {
		var index = arr.indexOf(val);
		if (index > -1) {
			arr.splice(index, 1);
		}
	}

	timeSuffix(){
	　　 var dd = new Date();
	　　 var y = dd.getFullYear();
	　 　var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1).toString();
	　 　var d = dd.getDate() < 10 ? "0" + dd.getDate() : (dd.getDate()).toString();
		 var h = dd.getHours().toString();
		 var mini = dd.getMinutes().toString();
		 var s = dd.getSeconds().toString();
		return y + m + d + h + mini + s;
	}
}

export default new UTILS()